import styled from 'styled-components';
import { Stack } from '@spotify-internal/encore-web/ads-business';
import { cssSpacing, Type } from '@spotify-internal/encore-web/core';
import { useT } from '@spotify-internal/i18n-core';
import { PillInfo } from '@components/shared/PillInfo/PillInfo';
import { RowCell } from '@components/shared/styles';
import { EMPTY_VALUE } from '@helpers/constants';
import { PillsContainer } from '../RelatedTrack/styles';
import { FullRow } from './AvailabilityClearanceStatus';
export interface FlagProps {
  deliveredEnd: String;
  deliveredStart: String;
}

export const PaddedStack = styled(Stack)`
  padding: 28px;
`;

export const AvailabilityFlagStatus = ({
  deliveredEnd,
  deliveredStart,
}: FlagProps) => {
  const t = useT();

  return (
    <PaddedStack>
      <div>
        <Type
          variant="cello"
          paddingBottom={cssSpacing('tighter-4', '8px')}
          as="h2"
          semanticColor="textBase"
        >
          {t(
            'atlas.labels.most_recent_availability',
            'Most recent availability',
            'Label for the previously delivered availability dates of the blocked release',
          )}
        </Type>

        <Type variant="viola" paddingBottom={cssSpacing('base', '24px')}>
          {t(
            'atlas.warnings.most_recent_availability_not_applicable',
            'The most recent availability you set for this release is no longer applicable. Please reach out to Content Ops for more info.',
            'Warning text',
          )}
        </Type>
      </div>
      <PillsContainer>
        <FullRow>
          <RowCell marginRight>
            <PillInfo
              label={t(
                'atlas.labels.start_date',
                'Start date',
                'Label text for start date (i.e. 2022-04-12 00:00:00)',
              )}
              value={deliveredStart || EMPTY_VALUE}
              tooltipMessage={undefined}
              backgroundColor="backgroundHighlight"
            />
          </RowCell>
          <RowCell marginLeft>
            <PillInfo
              label={t(
                'atlas.labels.end_date',
                'End date',
                'Label text for end date (i.e. 2022-08-12 00:00:00)',
              )}
              value={deliveredEnd || EMPTY_VALUE}
              tooltipMessage={undefined}
              backgroundColor="backgroundHighlight"
            />
          </RowCell>
        </FullRow>
      </PillsContainer>
    </PaddedStack>
  );
};
